<template>
  <div class="container-404">
    <div class="wrapper-content">
      <div class="wrapper-image">
        <img src="@/assets/404.svg" alt="">
      </div>
      <div class="wrapper-message">
        페이지를 찾을 수 없습니다
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  created() {
    if (this.$store.getters.isFold) return;

    this.$store.commit('setFoldState', true);
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #e6e9ec;
}
.container-404 {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper-content {
  text-align: center;
  .wrapper-image {
    width: 400px;
    margin: 0 auto;
    img {
      width: 100%;
      opacity: 0.7;
      filter: blur(8px);
    }
  }
  .wrapper-message {
    margin-top: 48px;
    font-size: 18px;
    color: #a0a3a7;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/pages/NotFound.vue